import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    // Only initialize if measurement ID is provided
    if (!measurementId) {
      console.warn('Google Analytics: REACT_APP_GA_MEASUREMENT_ID not found in environment variables');
      return;
    }

    // Initialize Google Analytics
    const initGA = () => {
      // Create gtag function
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      // Initialize gtag
      gtag('js', new Date());
      gtag('config', measurementId, {
        page_title: document.title,
        page_location: window.location.href,
      });

      // Load the Google Analytics script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);
    };

    // Initialize GA if not already done
    if (!window.gtag) {
      initGA();
    }
  }, [measurementId]);

  useEffect(() => {
    // Track page views when location changes
    if (window.gtag && measurementId) {
      window.gtag('config', measurementId, {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }
  }, [location, measurementId]);

  // This component doesn't render anything
  return null;
};

export default GoogleAnalytics;